<template>
  <v-main>
    <v-app-bar
      fixed
      color="grey lighten-4"
      dense
      flat
    >
      <v-btn
        icon
        :to="($i18n.locale == 'en') ? '/en' : '/'"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>利用規約</v-toolbar-title>

    </v-app-bar>

    <v-container mt-12 py-6 px-6>
      <p class="text">本利用規約（以下「本規約」と言います。）には、本サービスの提供条件及び当方と利用ユーザーの皆様との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいたうえで、本規約に同意いただく必要があります。</p>

      <p class="item">第1条（適用）</p>
      <ol>
          <li>本規約は、本サービスの提供条件及び本サービスの利用に関する当方と利用ユーザーとの間の権利義務関係を定めることを目的とし、利用ユーザーと当方との間の本サービスの利用に関わる一切の関係に適用されます。</li>
          <li>本規約の内容と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されるものとします。</li>
      </ol>

      <p class="item">第2条（定義）</p>
      <p class="text">本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。</p>
      <ol>
          <li>「サービス利用契約」とは、本規約及び当方と利用ユーザーの間で締結する、本サービスの利用契約を意味します。</li>
          <li>「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）を意味します。</li>
          <li>「登録データ」とは、利用ユーザーが本サービスを利用して登録したコンテンツ（文章、配置等のデータ）を意味します。</li>
          <li>「当方」とは、本サービスの管理者を意味します。</li>
          <li>「当方ウェブサイト」とは、そのドメインが「www.positioning-map.com」である、当方が運営するウェブサイト（理由の如何を問わず、当方のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。</li>
          <li>「利用ユーザー」とは、第3条（利用）に基づいて本サービスを利用した個人または法人を意味します。</li>
          <li>「本サービス」とは、当方が提供する「ポジショニングマップ.COM」という名称のサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。</li>
      </ol>

      <p class="item">第3条（利用）</p>
      <p class="text">本サービスの利用する者（以下「利用ユーザー」といいます。）は、本規約を遵守することに同意し、本サービスを利用した時に、サービス利用契約が利用ユーザーと当方の間に成立し、利用ユーザーは本サービスを本規約に従い利用することができるようになります。</p>

      <p class="item">第4条（禁止事項）</p>
      <p class="text">利用ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当方が判断する行為をしてはなりません。</p>
      <ol>
          <li>法令に違反する行為または犯罪行為に関連する行為</li>
          <li>当方、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為</li>
          <li>公序良俗に反する行為</li>
          <li>当方、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為</li>
          <li>本サービスを通じ、以下に該当し、または該当すると当方が判断する情報を当方または本サービスの他の利用者に送信すること
              <ul>
                  <li>過度に暴力的または残虐な表現を含む情報</li>
                  <li>コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報</li>
                  <li>当方、本サービスの他の利用者またはその他の第三者の名誉または信用を毀損する表現を含む情報</li>
                  <li>過度にわいせつな表現を含む情報</li>
                  <li>差別を助長する表現を含む情報</li>
                  <li>自殺、自傷行為を助長する表現を含む情報</li>
                  <li>薬物の不適切な利用を助長する表現を含む情報</li>
                  <li>反社会的な表現を含む情報</li>
                  <li>チェーンメール等の第三者への情報の拡散を求める情報</li>
                  <li>他人に不快感を与える表現を含む情報</li>
                  <li>面識のない異性との出会いを目的とした情報</li>
              </ul>
          </li>
          <li>本サービスのネットワークまたはシステム等に過度な負荷をかける行為</li>
          <li>本サービスの運営を妨害するおそれのある行為</li>
          <li>当方のネットワークまたはシステム等に不正にアクセスし、または不正なアクセスを試みる行為</li>
          <li>第三者に成りすます行為</li>
          <li>本サービスの他の利用者のバックアップコードを不正に利用する行為</li>
          <li>当方が事前に許諾しない本サービス上での宣伝、広告、勧誘、または営業行為</li>
          <li>本サービスの他の利用者の情報の収集</li>
          <li>当方、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為</li>
          <li>反社会的勢力等への利益供与</li>
          <li>面識のない異性との出会いを目的とした行為</li>
          <li>前各号の行為を直接または間接に惹起し、または容易にする行為</li>
          <li>その他、当方が不適切と判断する行為</li>
      </ol>

      <p class="item">第5条（外部サービス）</p>
      <ol>
          <li>本サービスは、Twitter、Facebook等の外部サービスと連携してサービスを提供することがありますが、利用ユーザーは、自らの責任において外部サービスを利用するものとし、当方は、外部サービスの利用に関連して利用ユーザーに発生した損害について、一切の責任を負いません。</li>
          <li>利用ユーザーは、外部サービスの利用に当たっては、外部サービスの利用規約等を遵守するものとします。</li>
          <li>当方は、外部サービスの利用規約等によって、利用ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。</li>
          <li>当方は、本条に基づき当方が行った行為により利用ユーザーに生じた損害について一切の責任を負いません。</li>
      </ol>

      <p class="item">第6条（本サービスの停止等）</p>
      <ol>
          <li>当方は、以下のいずれかに該当する場合には、利用ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。
              <ul>
                  <li>本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合</li>
                  <li>コンピューター、通信回線等が事故により停止した場合</li>
                  <li>地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
                  <li>その他、当方が停止または中断を必要と判断した場合</li>
              </ul>
          </li>
          <li>当方は、本条に基づき当方が行った措置に基づき利用ユーザーに生じた損害について一切の責任を負いません。</li>
      </ol>

      <p class="item">第7条（権利帰属）</p>
      <ol>
          <li>当方ウェブサイト及び本サービスに関する知的財産権は全て当方または当方にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、当方ウェブサイトまたは本サービスに関する当方または当方にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。</li>
          <li>利用ユーザーは、登録データについて、自らが登録その他送信することについての適法な権利を有していること、及び登録データが第三者の権利を侵害していないことについて、当方に対し表明し、保証するものとします。</li>
          <li>利用ユーザーは、登録データについて、当方に対し、世界的、非独占的、無償、サブライセンス可能かつ譲渡可能な使用、複製、配布、派生著作物の作成、表示及び実行に関するライセンスを付与します。また、他の利用ユーザーに対しても、本サービスを利用してユーザが登録その他送信した登録データの使用、複製、配布、派生著作物を作成、表示及び実行することについての非独占的なライセンスを付与します。</li>
          <li>利用ユーザーは、当方及び当方から権利を承継しまたは許諾された者に対して著作者人格権を行使しないことに同意するものとします。</li>
      </ol>

      <p class="item">第8条（登録データの抹消等）</p>
      <ol>
          <li>当方は、利用ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、登録データを削除することができます。
              <ul>
                  <li>本規約のいずれかの条項に違反した場合</li>
                  <li>登録事項に虚偽の事実があることが判明した場合</li>
                  <li>当方からの問いあわせその他の回答を求める連絡に対して30日間以上応答がない場合</li>
                  <li>当方が本サービスの利用として適当でないと判断した場合</li>
                  <li>その他、当方が本サービスの利用、利用ユーザーとしてサービス利用契約の継続を適当でないと判断した場合</li>
              </ul>
          </li>
          <li>当方は、本条に基づき当方が行った行為により利用ユーザーに生じた損害について一切の責任を負いません。</li>
      </ol>

      <p class="item">第9条（本サービスの内容の変更、終了）</p>
      <ol>
          <li>当方は、当方の都合により、本サービスの内容を変更し、または提供を終了することができます。当方が本サービスの提供を終了する場合、当方は利用ユーザーに事前に当方ウェブサイトで通知するものとします。</li>
          <li>当方は、本条に基づき当方が行った措置に基づき利用ユーザーに生じた損害について一切の責任を負いません。</li>
      </ol>

      <p class="item">第10条（保証の否認及び免責）</p>
      <ol>
          <li>当方は、本サービスが利用ユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用ユーザーによる本サービスの利用が利用ユーザーに適用のある法令または業界団体の内部規則等に適合すること、及び不具合が生じないことについて、何ら保証するものではありません。</li>
          <li>当方は、当方による本サービスの提供の中断、停止、終了、利用不能または変更、利用ユーザーが本サービスに登録したデータの消失または機器の故障もしくは損傷、その他本サービスに関して利用ユーザーが被った損害につき、賠償する責任を一切負わないものとします。</li>
          <li>本サービスまたは当方ウェブサイトに関連して利用ユーザーと他の利用ユーザーまたは第三者との間において生じた取引、連絡、紛争等については、当方は一切責任を負いません。</li>
      </ol>

      <p class="item">第11条（秘密保持）</p>
      <p class="text">利用ユーザーは、本サービスに関連して当方が利用ユーザーに対して秘密に取り扱うことを求めて開示した非公知の情報について、当方の事前の書面による承諾がある場合を除き、秘密に取り扱うものとします。</p>

      <p class="item">第12条（本規約等の変更）</p>
      <p class="text">当方は、本規約を変更できるものとします。当方は、本規約を変更した場合には、利用ユーザーに当該変更内容を当方ウェブサイトで通知するものとし、当該変更内容の通知後、利用ユーザーが本サービスを利用した場合には、利用ユーザーは、本規約の変更に同意したものとみなします。</p>

      <p class="item">第13条（連絡／通知）</p>
      <p class="text">本サービスに関する問い合わせその他利用ユーザーから当方に対する連絡または通知、及び本規約の変更に関する通知その他当方から利用ユーザーに対する連絡または通知は、当方の定める方法で行うものとします。</p>

      <p class="item">第14条（サービス利用契約上の地位の譲渡等）</p>
      <ol>
          <li>利用ユーザーは、当方の書面による事前の承諾なく、サービス利用契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</li>
          <li>当方は本サービスを他社もしくは他者に譲渡した場合には、サービス利用契約上の地位、本規約に基づく権利及び義務並びに利用ユーザーの登録事項を譲受人に譲渡することができるものとし、利用ユーザーは、かかる譲渡につき本項において予め同意したものとします。</li>
      </ol>

      <p class="item">第15条（分離可能性）</p>
      <p class="text">本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。</p>

      <p class="item">第16条（準拠法及び管轄裁判所）</p>
      <ol>
          <li>本規約及びサービス利用契約の準拠法は日本法とします。</li>
          <li>本規約またはサービス利用契約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
      </ol>

      <p class="date">2020年9月4日制定</p>
    </v-container>
  </v-main>
</template>

<script>
export default {
  metaInfo: {
    title: 'ポジショニングマップ.COMの利用規約',
    meta: [
      { name: 'description', content: 'ポジショニングマップ.COMはのご利用は無料ですが、自己責任でお願いします。' }
    ]
  }
}
</script>

<style lang="scss" scoped>
p {
  line-height: 1.8;
  &.item {
    margin-top: 24px;
    font-size: 16px;
  }
  &.text {
    font-size: 14px;
  }
  &.date {
    font-size: 14px;
    margin-top: 40px;
    text-align: right;
  }
}
li {
  line-height: 1.8;
  font-size: 14px;
}
</style>
